import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../icon/Icon';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

const defaultInputClass = 'ncss-input pt4-sm';
const defaultTextAreaClass = 'ncss-textarea mt4-sm';

export class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = { showPassword: false, isCapsLockOn: false };
  }

  togglePassword = () => {
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  checkCapsLock = event => {
    if (event.getModifierState('CapsLock')) {
      this.setState(() => ({ isCapsLockOn: true }));
    } else {
      this.setState(() => ({ isCapsLockOn: false }));
    }
  };

  render() {
    const {
      clearable,
      disabled,
      disabledWithValue,
      textArea,
      extraClassName,
      value,
      formName,
      name,
      intl,
      placeholder,
      isPassword,
      type,
      onChange: propsOnChange,
      ...rest
    } = this.props;
    const { showPassword, isCapsLockOn } = this.state;

    let onChange;

    if (propsOnChange) {
      onChange = e => propsOnChange(e.target.value);
    }

    const isTextArea = type === 'textarea' || textArea;
    const id = name.split(' ').join('_');

    const textProps = {
      ...rest,
      id: name,
      className: classnames(isTextArea ? defaultTextAreaClass : defaultInputClass, {
        hasValue: value && value.length > 0,
        [`${extraClassName}`]: !!extraClassName
      }),
      onChange,
      value,
      clearable: clearable ? 'true' : 'false',
      disabled: (disabled && !value) || disabledWithValue,
      placeholder: placeholder && placeholder.id ? new TranslatedCopy({ id: placeholder.id }).toString() : placeholder,
      'data-desc': `${formName || id}__${name}`,
      type: isPassword && !showPassword ? 'password' : 'text',
      onKeyUp: this.checkCapsLock
    };

    return isTextArea ? (
      <textarea {...textProps} />
    ) : (
      <>
        {isPassword && (
          <span className='passwordIcon mr2-sm'>
            <Icon
              name='eye'
              alt='view icon'
              onClick={this.togglePassword}
              title={new TranslatedCopy({ id: `login.password.${showPassword ? 'hide' : 'show'}` }).toString()}
            />
          </span>
        )}
        <input {...textProps} />
        {isPassword && isCapsLockOn && (
          <div style={{ color: '#ff0000', fontSize: '12px', position: 'absolute', width: '100%', textAlign: 'right' }}>
            <TranslatedCopy id='login.password.capsLockOn' />
          </div>
        )}
      </>
    );
  }
}

TextInput.defaultProps = {
  className: null,
  clearable: false,
  disabled: false,
  disabledWithValue: false,
  extraClassName: '',
  formName: null,
  intl: {},
  isPassword: false,
  label: '',
  onChange: null,
  placeholder: '',
  textArea: false,
  type: null,
  value: undefined
};

TextInput.propTypes = {
  disabled: PropTypes.bool,
  disabledWithValue: PropTypes.bool,
  className: PropTypes.string,
  clearable: PropTypes.bool,
  extraClassName: PropTypes.string,
  formName: PropTypes.string,
  intl: PropTypes.object,
  isPassword: PropTypes.bool,
  label: PropTypes.any,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.any,
  textArea: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default TextInput;
